import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getMain() {
        try{            
            const response = await axios.get(`Annualization`,
            {
                headers: {
                    'page_key': pageKeys.annualization
                }
            })                       
            return response
        }catch (error){
            console.log('Annualization api getMain error')
            throw error
        }
    },
    async getByUser(fiscalYear,userId) {
        try{            
            const response = await axios.get(`Annualization/${fiscalYear}/${userId}`,
            {
                headers: {
                    'page_key': pageKeys.annualization
                }
            })                       
            return response
        }catch (error){
            console.log('Annualization api getByUser error')
            throw error
        }
    },
    async getByFiscalPeriod(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Annualization/${fiscalPeriodId}`,
            {
                headers: {
                    'page_key': pageKeys.annualization
                }
            })                        
            return response
        }catch (error){
            console.log('Annualization api getByFiscalPeriod error')
            throw error
        }
    },
    async compute(data) {
        try{            
            const response = await axios.post(`Annualization/compute`,{
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api compute error')
            throw error
        }
    },
    async getPDFReport(fiscalPeriodId,userId) {
        try{            
            const response = await axios.get(`Annualization/pdf/${fiscalPeriodId}/${userId}`,{
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api getPDFReport error')
            throw error
        }
    },
    async getPDFUrl(fiscalPeriodId,userId) {
        try{            
            const response = await axios.get(`Annualization/pre-signed-url/${fiscalPeriodId}/${userId}`,{
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api getPDFUrl error')
            throw error
        }
    },
    async getMyPDFUrl(fiscalPeriodId,userId) {
        try{            
            const response = await axios.get(`Annualization/pre-signed-url/${fiscalPeriodId}`,{
                headers: {
                    'page_key': pageKeys.mypayslip
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api getMyPDFUrl error')
            throw error
        }
    },
    async get2316(fiscalPeriodId,userId) {
        try{            
            const response = await axios.get(`Annualization/pdf/2316/${fiscalPeriodId}/${userId}`,{
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api get2316 error')
            throw error
        }
    },
    async get2316Url(fiscalPeriodId,userId) {
        try{            
            const response = await axios.get(`Annualization/pre-signed-url/2316/${fiscalPeriodId}/${userId}`,{
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api get2316Url error')
            throw error
        }
    },
    async getMy2316Url(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Annualization/pre-signed-url/my-2316/${fiscalPeriodId}`,{
                headers: {
                    'page_key': pageKeys.mypayslip
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api getMy2316Url error')
            throw error
        }
    },
    async forReview(data) {
        try{            
            const response = await axios.post(`Annualization/forreview`,{
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.annualization
                }
            })             
            return response
        }catch (error){
            console.log('Annualization api forReview error')
            throw error
        }
    },
    async reject(data) {
        try{            
            const response = await axios.post(`Annualization/reject`,{
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.annualization
                }
            }) 
            return response
        }catch (error){
            console.log('Annualization api reject error')
            throw error
        }
    },
    async approve(data) {
        try{            
            const response = await axios.post(`Annualization/approve`,{
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.annualization
                }
            })    
            return response
        }catch (error){
            console.log('Annualization api approve error')
            throw error
        }
    },
    async adjustmentsProcessed(data) {
        try{            
            const response = await axios.post(`Annualization/adjustments-processed`,{
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.annualization
                }
            })    
            return response
        }catch (error){
            console.log('Annualization api adjustmentsProcessed error')
            throw error
        }
    },
    async get1604CSummary(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Annualization/pdf/1604C/${fiscalPeriodId}`,{
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api get1604CSummary error')
            throw error
        }
    },
    async get1604CUrl(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Annualization/pre-signed-url/1604C/${fiscalPeriodId}`,{
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api get1604CUrl error')
            throw error
        }
    },
    async getSummary(fiscalPeriodId) {
        try
        {            
            const response = await axios.get(`Annualization/xls/summary/${fiscalPeriodId}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api getSummary error')
            throw error
        }
    },
    async get1604CAlphalist(fiscalPeriodId) {
        try
        {            
            const response = await axios.get(`Annualization/xls/1604C/${fiscalPeriodId}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api get1604CAlphalist error')
            throw error
        }
    },
    async get1604CAlphalistMWE(fiscalPeriodId) {
        try
        {            
            const response = await axios.get(`Annualization/xls/1604C-MWE/${fiscalPeriodId}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('payroll api get1604CAlphalistMWE error')
            throw error
        }
    },
    async getDepositSlip(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Annualization/pdf/deposit-slip/${fiscalPeriodId}`,{
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api getDepositSlip error')
            throw error
        }
    },
    async getDepositSlipUrl(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Annualization/pre-signed-url/deposit-slip/${fiscalPeriodId}`,{
                headers: {
                    'page_key': pageKeys.annualization
                }
            })            
            return response
        }catch (error){
            console.log('Annualization api getDepositSlipUrl error')
            throw error
        }
    },
}